import { MenuIntemInterface } from './interfaces/menu-item.interface';
import { MenuCollapseInterface } from './interfaces/menu-collapse.interface';
import { MenuGroupInterface } from './interfaces/menu-group.interface';

export class AppNavigationModel {
  public model: MenuGroupInterface[] | MenuCollapseInterface[] | MenuIntemInterface[];

  constructor() {
    this.model = [
      {
        'id': 'applications',
        'title': 'Applications',
        'translate': 'LockerLink',
        'type': 'group',
        'icon': 'apps',
        'children': [
          {
            id: 'Home',                  
            title: 'Home',
            translate: 'NAV.Home',
            type: 'item',
            url: '/main',
            icon: 'home',
            visible: true
          },
          {
            'id': 'bulletin',
            'title': 'Bulletins',
            'translate': 'NAV.BULLETINS',
            'type': 'item',
            'url': '/main/bulletin',
            'icon': 'apps',
            visible: true,
          },
          {
            'id': 'report',
            'title': 'Report',
            'translate': 'NAV.REPORTS',
            'type': 'item',
            'url': '/main/report',
            'icon': 'view_timeline',
            visible: true,
          },
          {
            'id': 'dashboards',
            'title': 'Dashboards',
            'translate': 'NAV.ABOUT',
            'type': 'collapse',
            'icon': 'dashboard',
             visible: true,
            'children': [
              
              
              {
                id: 'Contact',                  
                title: 'Contact',
                translate: 'NAV.Contact',
                type: 'item',
                url: '/main/contact',
                icon: 'phone',
                visible: true
              },
              {
                id: 'Releases',                  
							  title: 'Last release',
                translate: 'NAV.LastRelease',
                type: 'item',
                url: '/main/release',
                icon: 'refresh',
                visible: true
              },
            ]
          },
        ]
      }
    ];
  }
}

